/* eslint-disable @typescript-eslint/no-empty-function */
import type { PropsWithChildren } from 'react';
import { useRef } from 'react';
import { useInView } from 'react-intersection-observer';

import type { NwtTrackingProps } from '../hooks/use-jobs-nwt-tracking';
import { useJobsNwtTracking } from '../hooks/use-jobs-nwt-tracking';

type Props = {
  nwtTrackingOptions?: NwtTrackingProps;
  onEnter?: () => void;
  skip?: boolean;
};

export const InViewTracking: React.FC<PropsWithChildren<Props>> = ({
  children,
  nwtTrackingOptions,
  onEnter,
  skip,
}) => {
  const isTrackedRef = useRef(false);
  const trackNwt = useJobsNwtTracking();

  const { ref } = useInView({
    onChange: (isVisible) => {
      if (!isVisible) {
        return;
      }

      onEnter?.();

      if (isTrackedRef.current) {
        return;
      }

      if (nwtTrackingOptions) {
        trackNwt(nwtTrackingOptions);
      }

      isTrackedRef.current = true;
    },
  });

  if (skip) {
    return children;
  }

  // The element is positioned to the left most corner so that that if it is
  // inside a carousel or similar, will only be tracked when they are
  // completely viewed. This takes the assumption that the carousel will be rtl
  return (
    <>
      {children}
      <div style={{ float: 'right' }} ref={ref} />
    </>
  );
};
